import type { ModuleDefinition } from "../../runtime/contracts";

import { Icon } from "../../components/ui";
import { ExtensionsPanel } from "./ExtensionsPanel";
import { createExtensionsStore } from "./store";

export const ExtensionsModule: ModuleDefinition = {
  id: "extensions",
  title: "Extensions",
  icon: <Icon name="extensions" size={26} />,
  iconName: "extensions",
  Component: ExtensionsPanel,
  createStore: (runtime) => createExtensionsStore(runtime),
};
